/**
 * ws的状态
 * 参考https://developer.mozilla.org/en-US/docs/Web/API/WebSocket
 */
export enum WebSocketState {
  NOTINITIALIZED = -1,
  CONNECTING = 0,
  OPEN = 1,
  CLOSING = 2,
  CLOSED = 3,
}
